// removed by extract-text-webpack-plugin
module.exports = {"download-button":"order-detail-export--download-button--1NTrBUGd","downloadButton":"order-detail-export--download-button--1NTrBUGd"};


//////////////////
// WEBPACK FOOTER
// ./views/order-detail/order-detail-export/styles.css
// module id = ./views/order-detail/order-detail-export/styles.css
// module chunks = 0